import { render } from "./Fact.vue?vue&type=template&id=7fdcda3b&scoped=true"
import script from "./Fact.vue?vue&type=script&lang=js"
export * from "./Fact.vue?vue&type=script&lang=js"

import "./Fact.vue?vue&type=style&index=0&id=7fdcda3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdcda3b"]])

export default __exports__